import * as React from "react";
import { EDPageLoader } from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";
import PageLayout from "../components/Shared/PageLayout";

const WatchNow = dynamic(() => import("../components/Pages/WatchNow/Public/WatchNow"), {
    suspense: false,
    ssr: false,
    loading: () => <EDPageLoader in={true}/>,
})

export default function TournamentsPage() {
    return <PageLayout
        backgroundStyles={{ backgroundPosition: "bottom" }}
        backgroundImage={"/watchnow/bg.webp"}
        alignItems={"center"}
        justifyContent={"flex-start"}>
        <WatchNow/>
    </PageLayout>
}

TournamentsPage.metaData = {
    title: 'Eternal Dragons - Witness Epic Battles',
    description: 'Experience the intensity of dragon warfare. Watch thrilling battles unfold in Eternal Dragons. Immerse yourself in the action now!'
}